export default __webpack_public_path__ + "static/media/DOM-DEC024.0e1322b3.jpg";